<div class="card card-{{ card }}" [class.card-rotated]="rotated" [class.card-compact]="compact"></div>
